import { useEffect } from 'react';
import { useSystemConfig } from './useSystemConfig';
import { systemConfigKeyEnum } from '../constants';

export const usePageTitle = (title: string) => {
    const { getConfigValue } = useSystemConfig();
    useEffect(() => {
        document.title = `${title} | ${process.env.REACT_APP_ENV === 'test' ? 'TEST ' : process.env.REACT_APP_ENV === 'development' ? 'DEV ' : ''}${'My SLTP'}`;
    }, [title]);
};
